import { message } from 'antd';
import { takeLatest, put } from 'redux-saga/effects';
import { StoreActionProps } from 'data/core';
import { logger } from 'services';
import {
  createDocumentTemplatePrivateSectionAction,
  CreateDocumentTemplatePrivateSection,
} from '../actions';
import { createDocumentTemplateSection } from '../slices';
import { DocumentTemplateContentSection } from '../types';

function* createDocumentTemplatePrivateSectionSaga(
  action: StoreActionProps<CreateDocumentTemplatePrivateSection>,
) {
  const {
    payload: { docId },
  } = action;

  try {
    const section: DocumentTemplateContentSection = {
      content: '<p></p>',
      documentSectionId: 0,
      meta: {
        sectionType: 'PRIVATE',
        resourceSections: [],
      },
      createdAt: +new Date(),
    };

    yield put(
      createDocumentTemplateSection({
        templateId: docId,
        section,
      }),
    );
  } catch (error) {
    logger.error('an error creating a private section in the document', {
      error,
    });

    message.error(
      'There was an error creating a private section in the document',
    );
  }
}

export function* watchCreateDocumentTemplatePrivateSectionSaga(): Generator {
  yield takeLatest(
    createDocumentTemplatePrivateSectionAction.type,
    createDocumentTemplatePrivateSectionSaga,
  );
}
